import { faFilePdf } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { t } from "i18next";
import { FC, Fragment } from "react";

export type InputFilepdfprops = {
  id: string;
  name: string;
  span: string;
  spanButton: string;
  description: string;
  label: string;
  error?: boolean;
  onFileChange?: (file: File | null) => void;
  selectedFileName?: string | null;
  onRemoveFile?: () => void;
  tittleDelete: string;
};

export const InputFilepdf: FC<InputFilepdfprops> = ({
  id,
  name,
  span,
  spanButton,
  description,
  label,
  error,
  onFileChange,
  selectedFileName,
  onRemoveFile,
  tittleDelete,
}) => {
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file && file.type === "application/pdf") {
      if (onFileChange) onFileChange(file); // Notificar al componente padre
    }
  };

  const handleRemoveFile = () => {
    if (onRemoveFile) onRemoveFile(); // Notificar al componente padre
  };

  return (
    <Fragment>
      <div>
        <div className="flex justify-between">
          <label
            htmlFor={id}
            className={`block text-sm font-medium leading-6 ${
              error ? "text-red-600" : "text-gray-900"
            }`}
          >
            {label}
          </label>
          <span
            className={`text-sm leading-6 ${
              error ? "text-red-600" : "text-gray-500"
            }`}
          >
            {span}
          </span>
        </div>
        <div className="mt-2 flex flex-col items-center justify-center">
          <div
            className={`flex justify-center items-center border-dashed border rounded-lg px-2 py-4 ${
              error ? "border-red-600" : "border-gray-900/25"
            } h-32 w-32 text-sm`}
          >
            <div className="text-center overflow-hidden">
              {selectedFileName ? (
                <p className="text-xs truncate line-clamp-2 text-gray-600">
                  {selectedFileName}
                </p>
              ) : (
                <>
                  <FontAwesomeIcon
                    icon={faFilePdf}
                    className="h-10 w-10 text-gray-500"
                  />
                  <div className="mt-4 flex justify-center text-sm leading-6 text-gray-600">
                    <label
                      htmlFor={id}
                      className="relative cursor-pointer rounded-md bg-white font-semibold text-primary-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 hover:text-indigo-500"
                    >
                      <span className="block text-center">{spanButton}</span>
                      <input
                        id={id}
                        name={name}
                        type="file"
                        accept=".pdf"
                        className="sr-only"
                        onChange={handleFileChange}
                      />
                    </label>
                  </div>
                  <p className="text-xs leading-5 text-gray-600">
                    {description}
                  </p>
                </>
              )}
            </div>
          </div>
          {selectedFileName ? (
            <div className="flex justify-center items-center px-2 py-4">
              <div className="text-center">
                <button
                  type="button"
                  onClick={handleRemoveFile}
                  className="mt-2 text-sm text-red-600 hover:text-red-800"
                >
                  {tittleDelete}
                </button>
                <label
                  htmlFor={id}
                  className="text-sm relative cursor-pointer rounded-md bg-white text-primary-600 hover:text-indigo-500"
                >
                  <span className="block text-center">
                    {t("general.change_archive")}
                  </span>
                  <input
                    id={id}
                    name={name}
                    type="file"
                    accept=".pdf"
                    className="sr-only"
                    onChange={handleFileChange}
                  />
                </label>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </Fragment>
  );
};
